import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import Colors from '../Constant/Colors';
import client from '../API/client';
import { useNavigate } from 'react-router-dom';
import ImageHome from '../assets/Images/connection.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { LoadingScreen } from '../components/global/LoadingScreen';
import Backdrop from '@mui/material/Backdrop';

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const [isloading, setIsLoading] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: (values) => {
      setIsLoading(true);
      const { email, password } = values;
      const payload = { email, password };
      const result = client
        .post('/login', payload, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(async (res) => {
          setIsLoading(false);
          localStorage.setItem('Role', JSON.stringify(res.data.User.user_role));
          localStorage.setItem('User_Email', JSON.stringify(res.data.User.user_email));
          localStorage.setItem('token', JSON.stringify(res.data.token));
          if (res.data.User.user_role === 'admin') {
            localStorage.setItem('user', JSON.stringify(res.data.User));
            navigate(`/admin/dashboard/${res.data.User.user_id}`);
          }
          if (res.data.User.user_role === 'designer') {
            localStorage.setItem('designer', JSON.stringify(res.data.Designer));
            localStorage.setItem('user_id', JSON.stringify(res.data.User.user_id));
            navigate(`/designer/dashboard/${res.data.User.user_id}`);
          }
          if (res.data.User.user_role === 'recruiter') {
            localStorage.setItem('recruiter', JSON.stringify(res.data.Recruiter));
            localStorage.setItem('user_id', JSON.stringify(res.data.User.user_id));
            navigate(`/recruiter/dashboard/${res.data.User.user_id}`);
          }
          if (result.status === '502') {
            setIsLoading(false);
            toast.error('Invalid Email or Password', {
              position: toast.POSITION.TOP_CENTER,
            });
          }else{
            toast.error('Invalid login credentials', {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        })
        .catch((err) => {
          // console.log(err)
          setIsLoading(false);
          // if (err.response.status === 502) {
          //   toast.error('Invalid Email or Password', {
          //     position: toast.POSITION.TOP_CENTER,
          //   });
          // }
          // else if (err.response.status === 401) {
          //   toast.error('Invalid Password, Check your password and try again', {
          //     position: toast.POSITION.TOP_CENTER,
          //   });
          // }else{
            toast.error('Invalid login credentials', {
              position: toast.POSITION.TOP_CENTER,
            });
          // }
        });
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid Email Address').required('Required'),
      password: Yup.string().min(4, 'Password must have atleast 4 characters').required('Password is required'),
    }),
  });

  return (
    <>
      {isloading && (
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
          <LoadingScreen />
        </Backdrop>
      )}

      <Box display="flex" height="88vh" justifyContent="center" alignItems="center" className="Homecmp">
        <ToastContainer />
        <Box
          height="75vh"
          width="80vw"
          justifyContent="center"
          flexDirection="row"
          alignItems="center"
          display="flex"
          sx={{
            boxShadow: '0.5rem 0.5rem 3rem -1rem black',
            borderRadius: '30px',
          }}>
          <Box
            height="80%"
            width="50%"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            marginLeft="20px"
            display="flex"
            sx={{
              boxShadow: '0.4rem 0.4rem 2.5rem -1rem gray',
              borderRadius: '30px',
              background: 'white',
            }}>
            <Typography variant="h3" sx={{ marginBottom: 4, fontFamily: 'serif' }}>
              {' '}
              Login
            </Typography>

            <form
              onSubmit={formik.handleSubmit}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%',
              }}>
              <TextField
                required
                label="Email"
                name="email"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.email}
                onBlur={formik.handleBlur}
                sx={{ width: '60%', margin: '10px' }}
              />
              {formik.touched.email && formik.errors.email ? (
                <div
                  style={{
                    color: 'red',
                    marginBottom: '2px',
                    marginTop: '-9px',
                    fontSize: '12px',
                  }}>
                  {formik.errors.email}
                </div>
              ) : (
                ''
              )}

              <TextField
                label="Password*"
                name="password"
                type={showPassword ? 'text' : 'password'}
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.password}
                onBlur={formik.handleBlur}
                sx={{ width: '60%', margin: '10px' }}
              />
              {formik.touched.password && formik.errors.password ? (
                <div
                  style={{
                    color: 'red',
                    marginBottom: '2px',
                    marginTop: '-9px',
                    fontSize: '12px',
                  }}>
                  {formik.errors.password}
                </div>
              ) : (
                ''
              )}
              <Button
                variant="contained"
                type="submit"
                sx={{
                  width: '60%',
                  margin: '40px',
                  background: Colors.secondary,
                  borderRadius: 30,
                  color: 'black',
                  '&:hover': {
                    backgroundColor: Colors.primary,
                    color: 'white',
                  },
                }}>
                Login
              </Button>
            </form>
          </Box>
          <Box
            height="80%"
            width="40%"
            marginLeft="20px"
            marginRight="20px"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            display="flex"
            sx={{
              boxShadow: '0.4rem 0.4rem 2.5rem -1rem gray',
              borderRadius: '30px',
              background: 'white',
            }}>
            <Typography variant="h4" sx={{ margin: '15px', fontFamily: 'serif', padding: '15px' }}>
              "Welcome to IconicArt !! : )"
            </Typography>
            <img src={ImageHome} style={{ height: '60%', width: '100%' }} />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Login;
